import React from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { Document } from '@contentful/rich-text-types';
import { RichText } from '../../richText';

interface CaseStudyContentAndDesktopImageProps {
  content: Document;
  image: Asset;
  contentLocation: string;
}

const SquareImage = styled.div`
    position: relative;

    @media(min-width: 1024px){
      width: 75%;
      margin-left: 12.5%;
      padding-bottom: 75%;
      overflow: hidden;
    }
    `;

export const CaseStudyContentAndImage: React.FC<CaseStudyContentAndDesktopImageProps> = ({
  content,
  image,
  contentLocation,
}) => {

  return (
    <div className="w-screen overflow-hidden cs-block-natural ">
      <div className={`w-full max-w-6xl px-8 pb-20 lg:pb-32 lg:flex lg:mx-auto lg:gap-5 ${contentLocation === 'Right' ? 'flex-row-reverse' : 'flex-row'}`}>
        <div className="mb-10 lg:mb-20 lg:w-1/2 lg:pt-8">
          <RichText content={content} />
        </div>
        <div className="relative lg:w-1/2">
          <SquareImage>
            <img src={image.url} alt={image.name} className={'lg:absolute object-cover w-full h-full'} />
          </SquareImage>
        </div>
      </div>
    </div>
  );
};
